import { ApiFarmerRewards } from '@api/interfaces/ApiFarmerRewards';
import { ApiRewardsProgram } from '@api/interfaces/ApiRewardsProgram';
import { ApiRewardsTier } from '@api/interfaces/ApiRewardsTier';
import { RewardsUom } from '@shared/enums/RewardsUom';
import { formatCurrency, formatNumber } from '@shared/utilities';

export const formatHurdleText = (
  amount: number,
  uom: RewardsUom,
  i18n: { language: string },
) => {
  return uom === RewardsUom.Dollars
    ? formatCurrency(amount, i18n)
    : `${formatNumber(amount, i18n, { maximumFractionDigits: 4 })} ${uom}`;
};

export const getRankCurrent = (
  farmerRewards: ApiFarmerRewards | undefined | null,
  rewardsProgram: ApiRewardsProgram,
) => {
  let rankCurrent = farmerRewards?.rankCurrent ?? null;
  const tierZero = rewardsProgram.tiers?.find((tier) => tier.rank === 0);
  if (
    rankCurrent === null
    && tierZero?.minimumDollars === 0
    && tierZero?.minimumSegments === 0
  ) {
    rankCurrent = 0;
  }
  return rankCurrent;
};

export const getRankEarned = (
  farmerRewards: ApiFarmerRewards | undefined | null,
  rewardsProgram: ApiRewardsProgram,
) => {
  let rankEarned = farmerRewards?.rankEarned ?? null;
  const tierZero = rewardsProgram.tiers?.find((tier) => tier.rank === 0);
  if (
    rankEarned === null
    && tierZero?.minimumDollars === 0
    && tierZero?.minimumSegments === 0
  ) {
    rankEarned = 0;
  }
  return rankEarned;
};

export const getTier = (rank: number, tiers: ApiRewardsTier[]) => {
  return tiers?.find(t => t.rank === rank);
};

export const getNextTier = (rank: number | null, tiers: ApiRewardsTier[]) => {
  return tiers?.find(t => rank === null ? t.rank === 0 : t.rank === rank + 1);
};

export const getFarmerRewardsProfile = (
  farmerReward: ApiFarmerRewards | null,
  rewardsProgram: ApiRewardsProgram | null,
) => {
  if (farmerReward) {
    return farmerReward;
  }
  if (rewardsProgram
    && rewardsProgram.tiers
    && rewardsProgram.tiers.find((tier) => tier.rank === 0)?.minimumDollars === 0) {
    return {
      accessToken: '',
      rankEarned: 0,
      id: '',
      rankCurrent: 0,
      program: rewardsProgram,
      programId: rewardsProgram.id,
      qualifyingTotalSpend: 0,
      rankOverride: null,
      segmentsHurdled: 0,
      segmentsRemaining: 0,
      totalPerSegment: {},
      totalSpend: 0,
    } as ApiFarmerRewards;
  }
  return undefined;
};
